export default "__VITE_ASSET__DMJKnqXH__"